<template>
    <b-container class="member-container">
        <b-container class="member_header">
                <div>
                    <b-img class="logo" src="/static/image/logo_white.png" />
                    <b-img src="/static/image/title.png" />
                </div>
                <div class="tz-flex">
                    <div @click="goFirst">
                        <b-img src="/static/image/icon_admin1_30x30.png" />
                        <span>首页</span>
                    </div>
                    <div>
                        <b-img src="/static/image/icon_admin2_30x30.png" />
                        <span>个人中心</span>
                    </div>
                    <div @click="loginout">
                        <b-img src="/static/image/icon_admin3_30x30.png" />
                        <span>退出</span>
                    </div>
                </div>
        </b-container>
        <b-container class="member_info">
            <b-row>
                <b-col sm="3" class="d-none d-sm-block">
                    <div class="left_panel">
                        <div>
                            <b-img src="/static/image/icon_admin4_30x30.png" /> 个人中心
                        </div>
                        <div>
                            个人信息
                        </div>
                    </div>
                </b-col>
                <b-col class="member-info">         
                        <div>
                            <b-img src="/static/image/admin_tx.jpg" />
                        </div>
                        <div class="info">
                            <div>
                                下午好，{{userInfo.name}}
                            </div>
                            <div>
                                <b-img src="/static/image/icon_admin5_20x20.png" />
                                <span><b-img src="/static/image/member_info_icon.jpg" />上次登录{{formatLastTime()}}前</span>
                            </div>
                            <div class="edit-container">
                                <div>
                                 <span> 上次登陆IP: {{userInfo.ip}}</span>
                                 <span> IP登陆地: {{userInfo.location}}</span>
                                </div>
                                <div>
                                    <b-button class="tz-btn tz-btn-edit" @click="visiable = !visiable ">编辑</b-button>
                                    <b-button class="tz-btn tz-btn-save" @click="saveInfo()">保存</b-button>
                                </div>
                            </div>
                          
                        </div>
                </b-col>
            </b-row>
        </b-container>
        <b-container class="tz-info-container">
            <b-row>
                <b-col sm="3" class="d-block d-sm-none">
                </b-col>
                <b-col class="edit-info" v-if="visiable">
                    <div class="member-table">
                        <div class="tz-row">
                            <div>
                                <span>姓名:</span><span>{{ userInfo.name}}</span>
                            </div>
                            <div>
                                <span>班级:</span><span>{{userInfo.className}}</span>
                            </div>
                        </div>
                        <div class="tz-row">
                            <div>
                                <span>学号:</span><span>{{userInfo.username}}</span>
                            </div>
                            <div>
                                <span>学校:</span><span>{{ userInfo.school }}</span>
                            </div>
                        </div>
                        <div class="tz-row">
                            <div>
                                <span>学历:</span><span>{{convertLevel(userInfo.levelId) }}</span>
                            </div>
                            <div>
                                <span>电话:</span> <b-input v-model="userInfo.mobile" required />
                            </div>
                        </div>
                        <div class="tz-row">
                            <div>
                                <span>邮箱:</span><b-input v-model="userInfo.email" required />
                            </div>
                            <div>
                                <span>密码:</span> <b-input v-model="userInfo.password" required />
                            </div>
                        </div>
                        <!-- <div class="tz-row">
                            <div>
                                 <span>省份:</span> 
                                 <b-select id="province" v-model="userInfo.provinceId" @change="provicneChange">
                                     <b-select-option v-for="item in provinceList" :key="'p'+item.id" :value="item.id">
                                         {{item.name}}
                                     </b-select-option>
                                 </b-select>
                            </div>
                            <div>
                                <span>层次:</span> <b-select v-model="userInfo.levelId" >
                                    <b-select-option v-for="item in levelList" :key="'l'+item.id" :value="item.id">
                                        {{item.name}}
                                    </b-select-option>
                                </b-select>
                            </div>
                        </div> -->
                    </div>
                </b-col>
            </b-row>
        </b-container>
        <tz-footer />
    </b-container>
</template>
<script>
import Footer from '@/components/footer'
import * as provinceApi from '@/api/province'
import * as levelApi from '@/api/level'
import { getInfo, setInfo } from '@/utils/auth'
import * as memberApi from '@/api/member'
import * as  auth  from '@/utils/auth'
export default {
    components:{
        "tz-footer": Footer
    },
    data(){
        return {
            visiable: true,
            userInfo: null,
            provinceList: [],
            levelList: []
        }
    },
    created(){
        this.userInfo = getInfo()
        if(!this.userInfo){
            this.$router.push({
                path: '/login'
            })
        }
        provinceApi.getList().then(res=>{
            if(res.code == 200){
                this.provinceList = res.data.list
                if(!this.userInfo.provinceId){
                    this.userInfo.provinceId = this.provinceList[0].id
                }
            }
            
        })
        levelApi.getList().then(res=>{
            if(res.code == 200 ){
                this.levelList = res.data.list
            }
        })
    },
    methods:{
        goFirst(){
            this.$router.push({
                path: '/'
            })
        },
        provicneChange(id){
        //    console.log(event)
            let pList = this.provinceList.filter(p=>p.id == id )
            if(!!pList){
                let cp = pList[0]
                this.userInfo.regionId = cp.regionId
            }
        },
        formatLastTime(){
            console.log(this.userInfo.lastLoginTime);
            let lt = new Date(this.userInfo.lastLoginTime)
            let now = new Date()
            let hours  = (now.getTime() - lt.getTime())/3600000
            let rs = ''
            if(hours>24){
                rs = Math.round(hours/24) +"天";
            }else{
                if(hours<1){
                    rs = Math.round((now.getTime() - lt.getTime())/60*1000 )+ "分钟"
                }else{
                    rs = Math.round(hours) +"小时";
                }
            }

            return rs
        },
        saveInfo(){
            memberApi.saveInfo(this.userInfo).then(res => {
                if(res.data){
                    this.userInfo.complete = true
                    setInfo(this.userInfo)
                    alert("操作成功")
                   
                }else{
                    alert(res.msg)
                }
            })
        },
        loginout(){
             auth.loginout()
             this.$router.push({
                path: '/'
            })
            this.$nextTick(()=>{
                memberApi.loginout().then(res=>{
                })
            })
        },
        convertLevel(id){
            let level = this.levelList.filter(item=>item.id == id)
            if(!!level&&level.length>0){
                return level[0].name
            }
            return "未知";
        }
    }    
}
</script>
<style scoped>
.tz-info-container{
    /* max-width: unset; */
    margin-right: 0;
    max-width: 75%;
}
.member-table{
    text-align: left;
}
.member-table input{
    /* width:15rem;  */
    width: 80%;
    display:inline-block;
    line-height: 1;
    border:  1px solid #cdcdcd;
    border-radius: 0;
}
.tz-row{
    display: flex;
    width: 100%;
    padding: 1rem;
    border-bottom: 1px solid #e5e5e5;
}
.tz-row:nth-child(even){
    background-color: #f7f7f7;
}
.tz-row>div{
    width: 50%;
   
}
.tz-row>div>span:nth-child(1){
    margin-right: 1rem;
}
.edit-info{
    background: white;
    margin: auto;
    padding: 0;
    box-shadow: -1px -1px 10px 1px #e9e9e9 ;
}
.member-container{
    width: 100%;
    height: 100%;
    max-width: unset;
}
.logo{
    width: 2rem;
    height: 2rem;
}
.tz-btn{
    margin-right: 1rem;
    line-height: 1;
    color: white;
    border: none;
    padding-left: 1rem;
    padding-right: 1rem;
}
.tz-btn-edit{
    background: #2989e9;
}
.tz-btn-save{
    background: #fc7b00;
}
.edit-container{
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #7b7b7b !important;
    font-weight: 800;
    font-size: 90%;
}
.member-info{
    display: flex;
    background-color: white;
    padding: 1rem;
    box-shadow: -1px -1px 10px 1px #e9e9e9 ;
    max-width: unset;
}
.member_header{
    background-image: url('/static/image/member_bg.jpg');
    background-size: cover;
    min-height: 90px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    max-width: unset;
}
.member_content{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 1rem;
    margin-top: 1rem;
}
.tz-flex{
    display: flex;
    color: white;
    align-items: center;
}
.tz-flex div{
    margin-right: 1rem;
    font-weight: 500;
}
.left_panel{
    background-color: white;
    margin-right: 1rem;
}
.left_panel div{
    padding: 0.5rem 3rem 0.5rem 3rem ;
}
.left_panel img{
    margin-right: 1rem;
}
.left_panel div:nth-child(1){
    background-color: #016fe7;
    /* background-image: linear-gradient(to rigth ,#00a0f1, #0163e4); */
    background-image: linear-gradient(to right, #00a1f1 , #0163e4);
    color: white;
    font-weight: bolder;
    text-align: left;
}
.member_info{
    padding: 1rem;
    max-width: unset;
}
.info{
    width: 100%;
}
.info>div{
    margin-top: .5rem;
    text-align: left;
    padding-left: 1rem;
}
.info>div:nth-child(1){
    font-weight: bold;
    color: black;
}
.info div:nth-child(2) span{
    display: inline-block;
    background-color: #fe7e01;
    border-radius: 10px;
    color: white;
    padding:  0 1rem 0 1rem;
}
.info div:nth-child(3) span{
    margin-right: 1rem;
}
</style>


// WEBPACK FOOTER //
// src/views/member/index.vue